<div
  class="sz-cta-bar"
  [class.sz-cta-bar--sticky]="variant() === 'sticky'"
  [class.sz-cta-bar--floating]="variant() === 'floating'"
  [class.sz-cta-bar--inline]="variant() === 'inline'"
  [class.sz-cta-bar--lift]="liftAboveTabbar()">
  <div class="sz-cta-bar__inner">
    <ng-content />
  </div>
</div>
